import { useState } from "react";

const C = { bg: "#111", border: "#1e1e1e", accent: "#e8700a", text: "#f5f5f5", dim: "#666" };

export function HourlyChart({ data, currency = "ARS" }) {
  const [hovered, setHovered] = useState(null);
  if (!data || data.length === 0) return <div style={{ color: C.dim, fontSize: 12, padding: "24px 0", textAlign: "center" }}>Sin datos de ventas por hora</div>;

  const max = Math.max(...data.map(d => d.total), 1);
  const sym = currency === "USD" ? "US$" : "$";

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      <div style={{ display: "flex", alignItems: "flex-end", gap: 3, height: 120, position: "relative" }}>
        {data.map((d, i) => {
          const pct = d.total / max;
          const isHov = hovered === i;
          return (
            <div key={i} style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", gap: 2, cursor: "pointer" }}
              onMouseEnter={() => setHovered(i)} onMouseLeave={() => setHovered(null)}>
              {isHov && (
                <div style={{ position: "absolute", bottom: 130, background: "#222", border: `1px solid ${C.border}`, borderRadius: 6, padding: "4px 8px", fontSize: 11, color: C.text, whiteSpace: "nowrap", zIndex: 10 }}>
                  {`${d.hora}:00 · ${sym}${d.total.toLocaleString("es-AR")} · ${d.transacciones} tx`}
                </div>
              )}
              <div style={{ width: "100%", height: `${pct * 100}%`, background: isHov ? "#ff8c20" : C.accent, borderRadius: "3px 3px 0 0", transition: "background .15s, height .4s ease", minHeight: d.total > 0 ? 3 : 0 }} />
            </div>
          );
        })}
      </div>
      <div style={{ display: "flex", gap: 3 }}>
        {data.map((d, i) => (
          <div key={i} style={{ flex: 1, textAlign: "center", fontSize: 9, color: C.dim }}>{d.hora}</div>
        ))}
      </div>
    </div>
  );
}
